import React, { useState, useEffect } from 'react'
import './AddBoxModalContainer.scoped.sass'

import { ReactComponent as CloseIcon } from '@/assets/icons/close-icon.svg'
import { Button } from '@/components/Button/Button'
import { InputMask } from '@/components/InputMask/InputMask'
import { Radio } from '@/components/Radio/Radio'
import contactslabelsService from '@/app-domains/contactslabels/contactslabels.service'
import modalService from '@/services/modal.service'

export function AddLabelToContactModalContainer (props) {
  const {
    contact
  } = props
  // eslint-disable-next-line
  const [errorMessage, setErrorMessage] = useState('')
  const [selectedLabels, setSelectedLabels] = useState(contactslabelsService.findLabelsForContact(contact))
  const [showLabelCreationInput, setShowLabelCreationInput] = useState(false)
  const [newLabelValue, setNewLabelValue] = useState('')
  const [newLabelErrorMessage, setNewLabelErrorMessage] = useState('')
  useEffect(() => {
    if (contact) {
      // setSelectedLabels(contactslabelsService.findLabelsForContact(contact))
    }
  }, [])

  function closeAddLabelModal () {
    modalService.close()
  }

  // eslint-disable-next-line
  const haveLabelsForContactChanged = (box, selectedLabels) => {
    if ((!box.boxlabels || box.boxlabels?.length === 0) && selectedLabels.length > 0) return true
    if (box.boxlabels.length !== selectedLabels.length) return true

    // If number of labels selected is the same than the one the box has, we have to compare them and check
    const labelsExistingInBox = selectedLabels.filter(
      label => {
        return box.boxlabels.filter(blabel => blabel.id === label.id).length > 0
      }).length
    return labelsExistingInBox !== selectedLabels.length
  }

  const addBox = async () => {
    if (!contact) {
      setErrorMessage('Field cannot be empty')
      return
    } else {
      setErrorMessage('')
    }

    if (showLabelCreationInput && newLabelValue.length === 0) {
      setNewLabelErrorMessage('Field cannot be empty')
      return
    }

    const promisesArray = []

    if (!showLabelCreationInput /* && haveLabelsForContactChanged(contact, selectedLabels) */) {
      const changeBoxLabelsPromise = contactslabelsService
        .attachLabelsToContact(contact, selectedLabels)
        .then(() => {}, (err) => {
          throw new Error(err)
        })
      promisesArray.push(changeBoxLabelsPromise)
    }

    if (showLabelCreationInput && newLabelValue.length > 0) {
      // eslint-disable-next-line
      const newLabel = await contactslabelsService.addContactLabel(newLabelValue)
      // await boxesService.attachLabelsToBox(box, newLabel.composedid)
    }

    Promise.all(promisesArray)
      .then(closeAddLabelModal)
      .then()
  }

  const onLabelSelected = (newlySelectedLabel) => {
    if (selectedLabels.find((label) => label.composedid === newlySelectedLabel.composedid)) {
      const newSelectedLabels = selectedLabels.filter((label) => label.composedid !== newlySelectedLabel.composedid)
      setSelectedLabels(newSelectedLabels)
    } else {
      setSelectedLabels([newlySelectedLabel, ...selectedLabels])
    }
  }

  return <div className='add-label-modal'>
    <div className="add-label-top">
      <div className="title">
        Edit contact labels
      </div>
      <div className="close-button" onClick={closeAddLabelModal}>
        <CloseIcon />
      </div>
    </div>
    <div className="select-label">
      <div className="select-label-title">
        Labels
      </div>
      { !showLabelCreationInput && <div className="radios">
        {Object.values(contactslabelsService.getAllStoredContactLabels()).map((label, index) => {
          return <Radio
            key={index}
            label={label?.name}
            name={label?.id}
            onChecked={() => onLabelSelected(label)}
            checked={selectedLabels.filter((sl) => sl.composedid === label.composedid).length > 0} />
        })}
      </div>
      }
      { !showLabelCreationInput && <div className="create-new-label-box-modal" onClick={() => setShowLabelCreationInput(true) }>
        I want to create a new label for this contact
      </div> }
      { showLabelCreationInput && <div className="input-label">
        <div className="input">
          <InputMask
            errorMessage={newLabelErrorMessage}
            value={newLabelValue}
            placeholder={'Please type label name'}
            onInput={setNewLabelValue}
            label='New label' />
        </div>
      </div>}
      { showLabelCreationInput && <div className="create-new-label-box-modal" onClick={() => setShowLabelCreationInput(false) }>
        Nevermind, I prefer to add an existing label to this contact
      </div> }
    </div>
    <div className="add-label-bottom">
      <div className="cancel">
        <Button type={'secondary'} content={'Cancel'} click={closeAddLabelModal} />
      </div>
      <div>
        <Button content='Save' click={addBox} />
      </div>
    </div>
  </div>
}
